const e = {
  "huspy-rebu-light": {
    "text-primary": "neutral.900",
    "text-primary_on-brand": "base.white",
    "text-secondary": "neutral.500",
    "text-secondary_hover": "neutral.600",
    "text-secondary_on-brand": "neutral.50",
    "text-tertiary": "neutral.400",
    "text-tertiary_hover": "neutral.500",
    "text-tertiary_on-brand": "neutral.50",
    "text-quaternary": "neutral.300",
    "text-quaternary_on-brand": "neutral.100",
    "text-white": "base.white",
    "text-disabled": "neutral.400",
    "text-placeholder": "neutral.400",
    "text-placeholder_subtle": "neutral.200",
    "text-brand-primary": "rebu.900",
    "text-brand-secondary": "rebu.600",
    "text-brand-tertiary": "rebu.400",
    "text-brand-tertiary_alt": "rebu.500",
    "text-success-primary": "success.800",
    "text-success-primary_alt": "success.500",
    "text-warning-primary": "warning.800",
    "text-warning-primary_alt": "warning.500",
    "text-error-primary": "error.800",
    "text-error-primary_alt": "error.500",
    "border-primary": "neutral.400",
    "border-primary_on-brand": "base.white",
    "border-secondary": "neutral.200",
    "border-tertiary": "neutral.100",
    "border-disabled": "neutral.200",
    "border-disabled_sublte": "neutral.50",
    "border-brand": "rebu.900",
    "border-brand-solid": "rebu.950",
    "border-brand-solid_alt": "rebu.950",
    "border-error": "error.800",
    "border-error_alt": "error.500",
    "fg-primary": "neutral.900",
    "fg-primary_on-brand": "base.white",
    "fg-secondary": "neutral.500",
    "fg-secondary_hover": "neutral.600",
    "fg-tertiary": "neutral.400",
    "border-warning": "warning.800",
    "fg-tertiary_hover": "neutral.500",
    "border-warning_alt": "warning.500",
    "border-success": "success.800",
    "border-success_alt": "success.500",
    "fg-senary": "neutral.100",
    "fg-white": "base.white",
    "fg-disabled": "neutral.400",
    "fg-disabled_alt": "neutral.100",
    "fg-disabled_subtle": "neutral.50",
    "fg-brand-primary": "rebu.900",
    "fg-brand-primary_alt": "rebu.800",
    "fg-brand-secondary": "rebu.600",
    "fg-success-primary": "success.800",
    "fg-success-primary_alt": "success.500",
    "fg-warning-primary": "warning.800",
    "fg-warning-primary_alt": "warning.500",
    "fg-error-primary": "error.800",
    "fg-error-primary_alt": "error.500",
    "bg-primary": "base.white",
    "bg-primary_hover": "neutral.50",
    "bg-secondary": "neutral.50",
    "bg-secondary_hover": "neutral.100",
    "bg-tertiary": "neutral.100",
    "bg-tertiary_hover": "neutral.200",
    "bg-tertiary_subtle": "neutral.50",
    "bg-quaternary": "neutral.200",
    "bg-quaternary_hover": "neutral.300",
    "bg-white": "base.white",
    "bg-active": "neutral.50",
    "bg-disabled": "neutral.100",
    "bg-disabled_subtle": "neutral.50",
    "bg-overlay": "neutral.700",
    "bg-brand-primary": "rebu.900",
    "bg-brand-primary_hover": "rebu.950",
    "bg-brand-primary_subtle": "rebu.800",
    "bg-brand-secondary": "rebu.50",
    "bg-brand-secondary_hover": "rebu.100",
    "bg-brand-secondary_subtle": "rebu.50",
    "bg-brand-solid": "rebu.900",
    "bg-brand-solid_hover": "rebu.800",
    "bg-success-primary": "success.100",
    "bg-success-solid": "success.500",
    "bg-success-solid_hover": "success.800",
    "bg-success-solid_alt": "success.600",
    "bg-warning-primary": "warning.100",
    "bg-warning-solid": "warning.500",
    "bg-warning-solid_alt": "warning.600",
    "bg-error-primary": "error.100",
    "bg-error-solid": "error.500",
    "bg-error-solid_alt": "error.600",
    "alpha-white-10": "white.4%",
    "alpha-white-20": "white.8%",
    "alpha-white-30": "white.12%",
    "alpha-white-40": "white.16%",
    "alpha-white-50": "white.24%",
    "alpha-white-60": "white.32%",
    "alpha-white-70": "white.48%",
    "alpha-white-80": "white.64%",
    "alpha-white-90": "white.80%",
    "alpha-white-100": "white.96%",
    "alpha-black-10": "black.4%",
    "alpha-black-20": "black.8%",
    "alpha-black-30": "black.12%",
    "alpha-black-40": "black.16%",
    "alpha-black-50": "black.24%",
    "alpha-black-60": "black.32%",
    "alpha-black-70": "black.48%",
    "alpha-black-80": "black.64%",
    "alpha-black-90": "black.80%",
    "alpha-black-100": "black.96%",
    "utility-blue-50": "blue.50",
    "utility-blue-100": "blue.100",
    "utility-blue-200": "blue.200",
    "utility-blue-300": "blue.300",
    "utility-blue-400": "blue.400",
    "utility-blue-500": "blue.500",
    "utility-blue-600": "blue.600",
    "utility-blue-700": "blue.700",
    "utility-blue-800": "blue.800",
    "utility-blue-900": "blue.900",
    "utility-blue-950": "blue.950",
    "utility-green-50": "green.50",
    "utility-green-100": "green.100",
    "utility-green-200": "green.200",
    "utility-green-300": "green.300",
    "utility-green-400": "green.400",
    "utility-green-500": "green.500",
    "utility-green-600": "green.600",
    "utility-green-700": "green.700",
    "utility-green-800": "green.800",
    "utility-green-900": "green.900",
    "utility-green-950": "green.950",
    "utility-beige-50": "beige.50",
    "utility-beige-100": "beige.100",
    "utility-beige-200": "beige.200",
    "utility-beige-300": "beige.300",
    "utility-beige-400": "beige.400",
    "utility-beige-500": "beige.500",
    "utility-beige-600": "beige.600",
    "utility-beige-700": "beige.700",
    "utility-beige-800": "beige.800",
    "utility-beige-900": "beige.900",
    "utility-beige-950": "beige.950",
    "utility-rose-50": "rose.50",
    "utility-rose-100": "rose.100",
    "utility-rose-200": "rose.200",
    "utility-rose-300": "rose.300",
    "utility-rose-400": "rose.400",
    "utility-rose-500": "rose.500",
    "utility-rose-600": "rose.600",
    "utility-rose-700": "rose.700",
    "utility-rose-800": "rose.800",
    "utility-rose-900": "rose.900",
    "utility-rose-950": "rose.950",
    "utility-indigo-50": "indigo.50",
    "utility-indigo-100": "indigo.100",
    "utility-indigo-200": "indigo.200",
    "utility-indigo-300": "indigo.300",
    "utility-indigo-400": "indigo.400",
    "utility-indigo-500": "indigo.500",
    "utility-indigo-600": "indigo.600",
    "utility-indigo-700": "indigo.700",
    "utility-indigo-800": "indigo.800",
    "utility-indigo-900": "indigo.900",
    "utility-indigo-950": "indigo.950",
    "button-primary-bg": "rebu.900",
    "button-primary-bg_hover": "rebu.950",
    "button-primary-bg_subtle": "rebu.800",
    "button-secondary-bg": "neutral.100",
    "button-secondary-bg_hover": "neutral.200",
    "button-secondary-bg_subtle": "neutral.50",
    "button-secondary-brand-bg": "rebu.100",
    "button-secondary-brand-bg_hover": "rebu.200",
    "button-secondary-brand-bg_subtle": "rebu.50",
    "button-tertiary-bg": "base.white",
    "button-tertiary-bg_hover": "black.8%",
    "button-tertiary-bg_subtle": "black.4%",
    "button-tertiary-brand-bg": "base.white",
    "button-tertiary-brand-bg_hover": "rebu.50",
    "button-quaternary-bg": "base.white",
    "button-quaternary-bg_hover": "black.4%",
    "button-quaternary-brand-bg": "base.white",
    "button-quaternary-brand-bg_hover": "rebu.50",
    "button-glassy-light-bg": "white.80%",
    "button-glassy-dark-bg": "black.8%",
    "button-white-bg": "base.white",
    "button-tertiary-border": "neutral.900",
    "button-tertiary-border_hover": "neutral.950",
    "button-glassy-border": "black.4%"
  },
  "huspy-rebu-dark": {
    "text-primary": "base.white",
    "text-primary_on-brand": "base.white",
    "text-secondary": "neutral.500",
    "text-secondary_hover": "neutral.400",
    "text-secondary_on-brand": "neutral.50",
    "text-tertiary": "neutral.600",
    "text-tertiary_hover": "neutral.500",
    "text-tertiary_on-brand": "neutral.50",
    "text-quaternary": "neutral.700",
    "text-quaternary_on-brand": "neutral.100",
    "text-white": "base.black",
    "text-disabled": "neutral.600",
    "text-placeholder": "neutral.600",
    "text-placeholder_subtle": "neutral.800",
    "text-brand-primary": "rebu.900",
    "text-brand-secondary": "rebu.600",
    "text-brand-tertiary": "rebu.400",
    "text-brand-tertiary_alt": "rebu.500",
    "text-success-primary": "success.400",
    "text-success-primary_alt": "success.500",
    "text-warning-primary": "warning.400",
    "text-warning-primary_alt": "warning.500",
    "text-error-primary": "error.400",
    "text-error-primary_alt": "error.500",
    "border-primary": "neutral.600",
    "border-primary_on-brand": "base.white",
    "border-secondary": "neutral.800",
    "border-tertiary": "neutral.900",
    "border-disabled": "neutral.600",
    "border-disabled_sublte": "neutral.800",
    "border-brand": "rebu.900",
    "border-brand-solid": "rebu.950",
    "border-brand-solid_alt": "rebu.950",
    "border-error": "error.400",
    "border-error_alt": "error.500",
    "fg-primary": "base.white",
    "fg-primary_on-brand": "neutral.900",
    "fg-secondary": "neutral.500",
    "fg-secondary_hover": "neutral.400",
    "fg-tertiary": "neutral.600",
    "border-warning": "warning.400",
    "fg-tertiary_hover": "neutral.500",
    "border-warning_alt": "warning.500",
    "border-success": "success.400",
    "border-success_alt": "success.500",
    "fg-senary": "white.8%",
    "fg-white": "base.white",
    "fg-disabled": "neutral.600",
    "fg-disabled_alt": "neutral.700",
    "fg-disabled_subtle": "neutral.800",
    "fg-brand-primary": "rebu.900",
    "fg-brand-primary_alt": "rebu.800",
    "fg-brand-secondary": "rebu.600",
    "fg-success-primary": "success.400",
    "fg-success-primary_alt": "success.500",
    "fg-warning-primary": "warning.400",
    "fg-warning-primary_alt": "warning.500",
    "fg-error-primary": "error.400",
    "fg-error-primary_alt": "error.500",
    "bg-primary": "white.16%",
    "bg-primary_hover": "white.24%",
    "bg-secondary": "white.12%",
    "bg-secondary_hover": "white.16%",
    "bg-tertiary": "white.8%",
    "bg-tertiary_hover": "white.4%",
    "bg-tertiary_subtle": "white.4%",
    "bg-quaternary": "white.4%",
    "bg-quaternary_hover": "white.8%",
    "bg-white": "base.white",
    "bg-active": "white.24%",
    "bg-disabled": "neutral.700",
    "bg-disabled_subtle": "neutral.800",
    "bg-overlay": "neutral.700",
    "bg-brand-primary": "rebu.900",
    "bg-brand-primary_hover": "rebu.950",
    "bg-brand-primary_subtle": "rebu.800",
    "bg-brand-secondary": "rebu.50",
    "bg-brand-secondary_hover": "rebu.100",
    "bg-brand-secondary_subtle": "rebu.50",
    "bg-brand-solid": "rebu.900",
    "bg-brand-solid_hover": "rebu.800",
    "bg-success-primary": "success.400",
    "bg-success-solid": "success.500",
    "bg-success-solid_hover": "success.700",
    "bg-success-solid_alt": "success.600",
    "bg-warning-primary": "warning.400",
    "bg-warning-solid": "warning.500",
    "bg-warning-solid_alt": "warning.600",
    "bg-error-primary": "error.400",
    "bg-error-solid": "error.500",
    "bg-error-solid_alt": "error.600",
    "alpha-white-10": "white.4%",
    "alpha-white-20": "white.8%",
    "alpha-white-30": "white.12%",
    "alpha-white-40": "white.16%",
    "alpha-white-50": "white.24%",
    "alpha-white-60": "white.32%",
    "alpha-white-70": "white.48%",
    "alpha-white-80": "white.64%",
    "alpha-white-90": "white.80%",
    "alpha-white-100": "white.96%",
    "alpha-black-10": "black.4%",
    "alpha-black-20": "black.8%",
    "alpha-black-30": "black.12%",
    "alpha-black-40": "black.16%",
    "alpha-black-50": "black.24%",
    "alpha-black-60": "black.32%",
    "alpha-black-70": "black.48%",
    "alpha-black-80": "black.64%",
    "alpha-black-90": "black.80%",
    "alpha-black-100": "black.96%",
    "utility-blue-50": "blue.50",
    "utility-blue-100": "blue.100",
    "utility-blue-200": "blue.200",
    "utility-blue-300": "blue.300",
    "utility-blue-400": "blue.400",
    "utility-blue-500": "blue.500",
    "utility-blue-600": "blue.600",
    "utility-blue-700": "blue.700",
    "utility-blue-800": "blue.800",
    "utility-blue-900": "blue.900",
    "utility-blue-950": "blue.950",
    "utility-green-50": "green.50",
    "utility-green-100": "green.100",
    "utility-green-200": "green.200",
    "utility-green-300": "green.300",
    "utility-green-400": "green.400",
    "utility-green-500": "green.500",
    "utility-green-600": "green.600",
    "utility-green-700": "green.700",
    "utility-green-800": "green.800",
    "utility-green-900": "green.900",
    "utility-green-950": "green.950",
    "utility-beige-50": "beige.50",
    "utility-beige-100": "beige.100",
    "utility-beige-200": "beige.200",
    "utility-beige-300": "beige.300",
    "utility-beige-400": "beige.400",
    "utility-beige-500": "beige.500",
    "utility-beige-600": "beige.600",
    "utility-beige-700": "beige.700",
    "utility-beige-800": "beige.800",
    "utility-beige-900": "beige.900",
    "utility-beige-950": "beige.950",
    "utility-rose-50": "rose.50",
    "utility-rose-100": "rose.100",
    "utility-rose-200": "rose.200",
    "utility-rose-300": "rose.300",
    "utility-rose-400": "rose.400",
    "utility-rose-500": "rose.500",
    "utility-rose-600": "rose.600",
    "utility-rose-700": "rose.700",
    "utility-rose-800": "rose.800",
    "utility-rose-900": "rose.900",
    "utility-rose-950": "rose.950",
    "utility-indigo-50": "indigo.50",
    "utility-indigo-100": "indigo.100",
    "utility-indigo-200": "indigo.200",
    "utility-indigo-300": "indigo.300",
    "utility-indigo-400": "indigo.400",
    "utility-indigo-500": "indigo.500",
    "utility-indigo-600": "indigo.600",
    "utility-indigo-700": "indigo.700",
    "utility-indigo-800": "indigo.800",
    "utility-indigo-900": "indigo.900",
    "utility-indigo-950": "indigo.950",
    "button-primary-bg": "rebu.100",
    "button-primary-bg_hover": "rebu.50",
    "button-primary-bg_subtle": "rebu.200",
    "button-secondary-bg": "neutral.700",
    "button-secondary-bg_hover": "neutral.600",
    "button-secondary-bg_subtle": "neutral.800",
    "button-secondary-brand-bg": "rebu.100",
    "button-secondary-brand-bg_hover": "rebu.200",
    "button-secondary-brand-bg_subtle": "rebu.50",
    "button-tertiary-bg": "base.white",
    "button-tertiary-bg_hover": "black.8%",
    "button-tertiary-bg_subtle": "black.4%",
    "button-tertiary-brand-bg": "base.white",
    "button-tertiary-brand-bg_hover": "rebu.50",
    "button-quaternary-bg": "base.white",
    "button-quaternary-bg_hover": "black.4%",
    "button-quaternary-brand-bg": "base.white",
    "button-quaternary-brand-bg_hover": "rebu.50",
    "button-glassy-light-bg": "white.80%",
    "button-glassy-dark-bg": "black.8%",
    "button-white-bg": "base.white",
    "button-tertiary-border": "neutral.400",
    "button-tertiary-border_hover": "neutral.500",
    "button-glassy-border": "black.4%"
  },
  "mortgage-light": {
    "text-primary": "neutral.900",
    "text-primary_on-brand": "base.white",
    "text-secondary": "neutral.500",
    "text-secondary_hover": "neutral.600",
    "text-secondary_on-brand": "neutral.50",
    "text-tertiary": "neutral.400",
    "text-tertiary_hover": "neutral.500",
    "text-tertiary_on-brand": "neutral.50",
    "text-quaternary": "neutral.300",
    "text-quaternary_on-brand": "neutral.100",
    "text-white": "base.white",
    "text-disabled": "neutral.400",
    "text-placeholder": "neutral.400",
    "text-placeholder_subtle": "neutral.200",
    "text-brand-primary": "mortgage.900",
    "text-brand-secondary": "mortgage.600",
    "text-brand-tertiary": "mortgage.400",
    "text-brand-tertiary_alt": "mortgage.500",
    "text-success-primary": "success.800",
    "text-success-primary_alt": "success.500",
    "text-warning-primary": "warning.800",
    "text-warning-primary_alt": "warning.500",
    "text-error-primary": "error.800",
    "text-error-primary_alt": "error.500",
    "border-primary": "neutral.400",
    "border-primary_on-brand": "base.white",
    "border-secondary": "neutral.200",
    "border-tertiary": "neutral.100",
    "border-disabled": "neutral.200",
    "border-disabled_sublte": "neutral.50",
    "border-brand": "mortgage.900",
    "border-brand-solid": "mortgage.950",
    "border-brand-solid_alt": "mortgage.950",
    "border-error": "error.800",
    "border-error_alt": "error.500",
    "fg-primary": "neutral.900",
    "fg-primary_on-brand": "base.white",
    "fg-secondary": "neutral.500",
    "fg-secondary_hover": "neutral.600",
    "fg-tertiary": "neutral.400",
    "border-warning": "warning.800",
    "fg-tertiary_hover": "neutral.500",
    "border-warning_alt": "warning.500",
    "border-success": "success.800",
    "border-success_alt": "success.500",
    "fg-senary": "neutral.100",
    "fg-white": "base.white",
    "fg-disabled": "neutral.400",
    "fg-disabled_alt": "neutral.100",
    "fg-disabled_subtle": "neutral.50",
    "fg-brand-primary": "mortgage.900",
    "fg-brand-primary_alt": "mortgage.800",
    "fg-brand-secondary": "mortgage.600",
    "fg-success-primary": "success.800",
    "fg-success-primary_alt": "success.500",
    "fg-warning-primary": "warning.800",
    "fg-warning-primary_alt": "warning.500",
    "fg-error-primary": "error.800",
    "fg-error-primary_alt": "error.500",
    "bg-primary": "base.white",
    "bg-primary_hover": "neutral.50",
    "bg-secondary": "neutral.50",
    "bg-secondary_hover": "neutral.100",
    "bg-tertiary": "neutral.100",
    "bg-tertiary_hover": "neutral.200",
    "bg-tertiary_subtle": "neutral.50",
    "bg-quaternary": "neutral.200",
    "bg-quaternary_hover": "neutral.300",
    "bg-white": "base.white",
    "bg-active": "neutral.50",
    "bg-disabled": "neutral.100",
    "bg-disabled_subtle": "neutral.50",
    "bg-overlay": "neutral.700",
    "bg-brand-primary": "mortgage.600",
    "bg-brand-primary_hover": "mortgage.700",
    "bg-brand-primary_subtle": "mortgage.500",
    "bg-brand-secondary": "mortgage.50",
    "bg-brand-secondary_hover": "mortgage.100",
    "bg-brand-secondary_subtle": "mortgage.50",
    "bg-brand-solid": "mortgage.600",
    "bg-brand-solid_hover": "mortgage.500",
    "bg-success-primary": "success.100",
    "bg-success-solid": "success.500",
    "bg-success-solid_hover": "success.800",
    "bg-success-solid_alt": "success.600",
    "bg-warning-primary": "warning.100",
    "bg-warning-solid": "warning.500",
    "bg-warning-solid_alt": "warning.600",
    "bg-error-primary": "error.100",
    "bg-error-solid": "error.500",
    "bg-error-solid_alt": "error.600",
    "alpha-white-10": "white.4%",
    "alpha-white-20": "white.8%",
    "alpha-white-30": "white.12%",
    "alpha-white-40": "white.16%",
    "alpha-white-50": "white.24%",
    "alpha-white-60": "white.32%",
    "alpha-white-70": "white.48%",
    "alpha-white-80": "white.64%",
    "alpha-white-90": "white.80%",
    "alpha-white-100": "white.96%",
    "alpha-black-10": "black.4%",
    "alpha-black-20": "black.8%",
    "alpha-black-30": "black.12%",
    "alpha-black-40": "black.16%",
    "alpha-black-50": "black.24%",
    "alpha-black-60": "black.32%",
    "alpha-black-70": "black.48%",
    "alpha-black-80": "black.64%",
    "alpha-black-90": "black.80%",
    "alpha-black-100": "black.96%",
    "utility-blue-50": "blue.50",
    "utility-blue-100": "blue.100",
    "utility-blue-200": "blue.200",
    "utility-blue-300": "blue.300",
    "utility-blue-400": "blue.400",
    "utility-blue-500": "blue.500",
    "utility-blue-600": "blue.600",
    "utility-blue-700": "blue.700",
    "utility-blue-800": "blue.800",
    "utility-blue-900": "blue.900",
    "utility-blue-950": "blue.950",
    "utility-green-50": "green.50",
    "utility-green-100": "green.100",
    "utility-green-200": "green.200",
    "utility-green-300": "green.300",
    "utility-green-400": "green.400",
    "utility-green-500": "green.500",
    "utility-green-600": "green.600",
    "utility-green-700": "green.700",
    "utility-green-800": "green.800",
    "utility-green-900": "green.900",
    "utility-green-950": "green.950",
    "utility-beige-50": "beige.50",
    "utility-beige-100": "beige.100",
    "utility-beige-200": "beige.200",
    "utility-beige-300": "beige.300",
    "utility-beige-400": "beige.400",
    "utility-beige-500": "beige.500",
    "utility-beige-600": "beige.600",
    "utility-beige-700": "beige.700",
    "utility-beige-800": "beige.800",
    "utility-beige-900": "beige.900",
    "utility-beige-950": "beige.950",
    "utility-rose-50": "rose.50",
    "utility-rose-100": "rose.100",
    "utility-rose-200": "rose.200",
    "utility-rose-300": "rose.300",
    "utility-rose-400": "rose.400",
    "utility-rose-500": "rose.500",
    "utility-rose-600": "rose.600",
    "utility-rose-700": "rose.700",
    "utility-rose-800": "rose.800",
    "utility-rose-900": "rose.900",
    "utility-rose-950": "rose.950",
    "utility-indigo-50": "indigo.50",
    "utility-indigo-100": "indigo.100",
    "utility-indigo-200": "indigo.200",
    "utility-indigo-300": "indigo.300",
    "utility-indigo-400": "indigo.400",
    "utility-indigo-500": "indigo.500",
    "utility-indigo-600": "indigo.600",
    "utility-indigo-700": "indigo.700",
    "utility-indigo-800": "indigo.800",
    "utility-indigo-900": "indigo.900",
    "utility-indigo-950": "indigo.950",
    "button-primary-bg": "mortgage.600",
    "button-primary-bg_hover": "mortgage.700",
    "button-primary-bg_subtle": "mortgage.500",
    "button-secondary-bg": "neutral.100",
    "button-secondary-bg_hover": "neutral.200",
    "button-secondary-bg_subtle": "neutral.50",
    "button-secondary-brand-bg": "mortgage.100",
    "button-secondary-brand-bg_hover": "mortgage.200",
    "button-secondary-brand-bg_subtle": "mortgage.50",
    "button-tertiary-bg": "base.white",
    "button-tertiary-bg_hover": "black.8%",
    "button-tertiary-bg_subtle": "black.4%",
    "button-tertiary-brand-bg": "base.white",
    "button-tertiary-brand-bg_hover": "mortgage.50",
    "button-quaternary-bg": "base.white",
    "button-quaternary-bg_hover": "black.4%",
    "button-quaternary-brand-bg": "base.white",
    "button-quaternary-brand-bg_hover": "mortgage.50",
    "button-glassy-light-bg": "white.80%",
    "button-glassy-dark-bg": "black.8%",
    "button-white-bg": "base.white",
    "button-tertiary-border": "neutral.900",
    "button-tertiary-border_hover": "neutral.950",
    "button-glassy-border": "black.4%"
  },
  "bayteca-light": {
    "text-primary": "neutral.900",
    "text-primary_on-brand": "base.white",
    "text-secondary": "neutral.500",
    "text-secondary_hover": "neutral.600",
    "text-secondary_on-brand": "neutral.50",
    "text-tertiary": "neutral.400",
    "text-tertiary_hover": "neutral.500",
    "text-tertiary_on-brand": "neutral.50",
    "text-quaternary": "neutral.300",
    "text-quaternary_on-brand": "neutral.100",
    "text-white": "base.white",
    "text-disabled": "neutral.400",
    "text-placeholder": "neutral.400",
    "text-placeholder_subtle": "neutral.200",
    "text-brand-primary": "bayteca.900",
    "text-brand-secondary": "bayteca.600",
    "text-brand-tertiary": "bayteca.400",
    "text-brand-tertiary_alt": "bayteca.500",
    "text-success-primary": "success.800",
    "text-success-primary_alt": "success.500",
    "text-warning-primary": "warning.800",
    "text-warning-primary_alt": "warning.500",
    "text-error-primary": "error.800",
    "text-error-primary_alt": "error.500",
    "border-primary": "neutral.400",
    "border-primary_on-brand": "base.white",
    "border-secondary": "neutral.200",
    "border-tertiary": "neutral.100",
    "border-disabled": "neutral.200",
    "border-disabled_sublte": "neutral.50",
    "border-brand": "bayteca.900",
    "border-brand-solid": "bayteca.950",
    "border-brand-solid_alt": "bayteca.950",
    "border-error": "error.800",
    "border-error_alt": "error.500",
    "fg-primary": "neutral.900",
    "fg-primary_on-brand": "base.white",
    "fg-secondary": "neutral.500",
    "fg-secondary_hover": "neutral.600",
    "fg-tertiary": "neutral.400",
    "border-warning": "warning.800",
    "fg-tertiary_hover": "neutral.500",
    "border-warning_alt": "warning.500",
    "border-success": "success.800",
    "border-success_alt": "success.500",
    "fg-senary": "neutral.100",
    "fg-white": "base.white",
    "fg-disabled": "neutral.400",
    "fg-disabled_alt": "neutral.100",
    "fg-disabled_subtle": "neutral.50",
    "fg-brand-primary": "bayteca.900",
    "fg-brand-primary_alt": "bayteca.800",
    "fg-brand-secondary": "bayteca.600",
    "fg-success-primary": "success.800",
    "fg-success-primary_alt": "success.500",
    "fg-warning-primary": "warning.800",
    "fg-warning-primary_alt": "warning.500",
    "fg-error-primary": "error.800",
    "fg-error-primary_alt": "error.500",
    "bg-primary": "base.white",
    "bg-primary_hover": "neutral.50",
    "bg-secondary": "neutral.50",
    "bg-secondary_hover": "neutral.100",
    "bg-tertiary": "neutral.100",
    "bg-tertiary_hover": "neutral.200",
    "bg-tertiary_subtle": "neutral.50",
    "bg-quaternary": "neutral.200",
    "bg-quaternary_hover": "neutral.300",
    "bg-white": "base.white",
    "bg-active": "neutral.50",
    "bg-disabled": "neutral.100",
    "bg-disabled_subtle": "neutral.50",
    "bg-overlay": "neutral.700",
    "bg-brand-primary": "bayteca.600",
    "bg-brand-primary_hover": "bayteca.700",
    "bg-brand-primary_subtle": "bayteca.500",
    "bg-brand-secondary": "bayteca.50",
    "bg-brand-secondary_hover": "bayteca.100",
    "bg-brand-secondary_subtle": "bayteca.50",
    "bg-brand-solid": "bayteca.600",
    "bg-brand-solid_hover": "bayteca.500",
    "bg-success-primary": "success.100",
    "bg-success-solid": "success.500",
    "bg-success-solid_hover": "success.800",
    "bg-success-solid_alt": "success.600",
    "bg-warning-primary": "warning.100",
    "bg-warning-solid": "warning.500",
    "bg-warning-solid_alt": "warning.600",
    "bg-error-primary": "error.100",
    "bg-error-solid": "error.500",
    "bg-error-solid_alt": "error.600",
    "alpha-white-10": "white.4%",
    "alpha-white-20": "white.8%",
    "alpha-white-30": "white.12%",
    "alpha-white-40": "white.16%",
    "alpha-white-50": "white.24%",
    "alpha-white-60": "white.32%",
    "alpha-white-70": "white.48%",
    "alpha-white-80": "white.64%",
    "alpha-white-90": "white.80%",
    "alpha-white-100": "white.96%",
    "alpha-black-10": "black.4%",
    "alpha-black-20": "black.8%",
    "alpha-black-30": "black.12%",
    "alpha-black-40": "black.16%",
    "alpha-black-50": "black.24%",
    "alpha-black-60": "black.32%",
    "alpha-black-70": "black.48%",
    "alpha-black-80": "black.64%",
    "alpha-black-90": "black.80%",
    "alpha-black-100": "black.96%",
    "utility-blue-50": "blue.50",
    "utility-blue-100": "blue.100",
    "utility-blue-200": "blue.200",
    "utility-blue-300": "blue.300",
    "utility-blue-400": "blue.400",
    "utility-blue-500": "blue.500",
    "utility-blue-600": "blue.600",
    "utility-blue-700": "blue.700",
    "utility-blue-800": "blue.800",
    "utility-blue-900": "blue.900",
    "utility-blue-950": "blue.950",
    "utility-green-50": "green.50",
    "utility-green-100": "green.100",
    "utility-green-200": "green.200",
    "utility-green-300": "green.300",
    "utility-green-400": "green.400",
    "utility-green-500": "green.500",
    "utility-green-600": "green.600",
    "utility-green-700": "green.700",
    "utility-green-800": "green.800",
    "utility-green-900": "green.900",
    "utility-green-950": "green.950",
    "utility-beige-50": "beige.50",
    "utility-beige-100": "beige.100",
    "utility-beige-200": "beige.200",
    "utility-beige-300": "beige.300",
    "utility-beige-400": "beige.400",
    "utility-beige-500": "beige.500",
    "utility-beige-600": "beige.600",
    "utility-beige-700": "beige.700",
    "utility-beige-800": "beige.800",
    "utility-beige-900": "beige.900",
    "utility-beige-950": "beige.950",
    "utility-rose-50": "rose.50",
    "utility-rose-100": "rose.100",
    "utility-rose-200": "rose.200",
    "utility-rose-300": "rose.300",
    "utility-rose-400": "rose.400",
    "utility-rose-500": "rose.500",
    "utility-rose-600": "rose.600",
    "utility-rose-700": "rose.700",
    "utility-rose-800": "rose.800",
    "utility-rose-900": "rose.900",
    "utility-rose-950": "rose.950",
    "utility-indigo-50": "indigo.50",
    "utility-indigo-100": "indigo.100",
    "utility-indigo-200": "indigo.200",
    "utility-indigo-300": "indigo.300",
    "utility-indigo-400": "indigo.400",
    "utility-indigo-500": "indigo.500",
    "utility-indigo-600": "indigo.600",
    "utility-indigo-700": "indigo.700",
    "utility-indigo-800": "indigo.800",
    "utility-indigo-900": "indigo.900",
    "utility-indigo-950": "indigo.950",
    "button-primary-bg": "bayteca.600",
    "button-primary-bg_hover": "bayteca.700",
    "button-primary-bg_subtle": "bayteca.500",
    "button-secondary-bg": "neutral.100",
    "button-secondary-bg_hover": "neutral.200",
    "button-secondary-bg_subtle": "neutral.50",
    "button-secondary-brand-bg": "bayteca.100",
    "button-secondary-brand-bg_hover": "bayteca.200",
    "button-secondary-brand-bg_subtle": "bayteca.50",
    "button-tertiary-bg": "base.white",
    "button-tertiary-bg_hover": "black.8%",
    "button-tertiary-bg_subtle": "black.4%",
    "button-tertiary-brand-bg": "base.white",
    "button-tertiary-brand-bg_hover": "bayteca.50",
    "button-quaternary-bg": "base.white",
    "button-quaternary-bg_hover": "black.4%",
    "button-quaternary-brand-bg": "base.white",
    "button-quaternary-brand-bg_hover": "bayteca.50",
    "button-glassy-light-bg": "white.80%",
    "button-glassy-dark-bg": "black.8%",
    "button-white-bg": "base.white",
    "button-tertiary-border": "neutral.900",
    "button-tertiary-border_hover": "neutral.950",
    "button-glassy-border": "black.4%"
  }
};
export {
  e as colorSemanticTokens
};
